import { defineAction } from '~/prix'
import propertyMachineryCreateAction from './propertyMachineryCreate.action.json' with { type: 'json' }

import { z } from 'zod'
import { propertyMachineryObject } from '../propertyMachineryObject'

const propertyMachineryCreateDefinition = defineAction({
  ...propertyMachineryCreateAction,

  input: propertyMachineryObject.pick({
    id: true,
    residenceId: true,
    machineryType: true,
    quantity: true,
    description: true,
    createdAt: true,
    updatedAt: true,
  }),
  output: z.object({}),
})

export default propertyMachineryCreateDefinition
